export default __webpack_public_path__ + "static/media/scoot.345a4bfd.svg";